import {
  Button,
  Empty,
  message,
  Modal,
  Spin
} from "antd";

import {
  CopyOutlined,
  PhoneOutlined,
  SendOutlined,
  ReloadOutlined,
  UserOutlined,
  ShoppingCartOutlined,
  CheckOutlined
} from "@ant-design/icons";

import {
  useEffect,
  useState
} from "react";

import axiosInstance from "../../../utils/axios";
import { FormatVND } from "../../../utils/format";


export default function PendingOrderManage() {

  const [orders, setOrders] =
    useState([]);

  const [loading, setLoading] =
    useState(false);


  const fetchOrders = async () => {

    setLoading(true);

    try {

      const res =
        await axiosInstance.get(
          "/order/getAll",
          {
            params: {
              page: 1,
              pageSize: 100,
              status: 0
            }
          }
        );


      const data =
        Array.isArray(
          res?.data?.data
        )
          ? res.data.data
          : [];


      /*
       * Don cu hon nam tren.
       * De xu ly lan luot.
       */
      data.sort(
        (a, b) =>
          Number(b?.order_id || 0) -
          Number(a?.order_id || 0)
      );


      setOrders(data);

    } catch (error) {

      console.error(
        "PENDING ORDER ERROR:",
        error
      );

      message.error(
        "Không tải được đơn hàng chưa xác nhận!"
      );

    } finally {

      setLoading(false);
    }
  };


  useEffect(() => {

    fetchOrders();

  }, []);


  const copyText = async (
    text,
    successMessage
  ) => {

    try {

      if (
        navigator.clipboard &&
        window.isSecureContext
      ) {

        await navigator.clipboard.writeText(
          String(text || "")
        );

      } else {

        const textarea =
          document.createElement(
            "textarea"
          );

        textarea.value =
          String(text || "");

        textarea.style.position =
          "fixed";

        textarea.style.opacity =
          "0";

        document.body.appendChild(
          textarea
        );

        textarea.focus();
        textarea.select();

        document.execCommand(
          "copy"
        );

        document.body.removeChild(
          textarea
        );
      }


      message.success(
        successMessage
      );

    } catch (error) {

      message.error(
        "Không sao chép được!"
      );
    }
  };


  const copyPhone = order => {

    copyText(
      order?.phone || "",
      "Đã sao chép số điện thoại"
    );
  };


  const getTransferMessage = order => {

    return (
      `Mã đơn ${order?.order_id} ` +
      `bạn chuyển giúp mình ` +
      `${FormatVND(order?.total_price || 0)}, ` +
      `chuyển xong nhắn mình nhé.`
    );
  };


  const copyTransferMessage = order => {

    copyText(
      getTransferMessage(order),
      "Đã sao chép nội dung"
    );
  };


  const moveToShipping = async order => {

    const orderId =
      order?.order_id;


    /*
     * OPTIMISTIC UI:
     * Bam la bien mat ngay.
     * Khong cho nguoi dung phai doi API.
     */
    setOrders(
      current =>
        current.filter(
          item =>
            Number(item?.order_id) !==
            Number(orderId)
        )
    );


    /*
     * Bao nhe ngay lap tuc.
     */
    message.success(
      `Đã xử lý đơn #${orderId}`,
      1
    );


    try {

      await axiosInstance.post(
        `/order/updateByStatus/${orderId}`,
        {
          status: 2
        }
      );

    } catch (error) {

      console.error(
        "UPDATE ORDER ERROR:",
        error
      );


      /*
       * Neu server loi:
       * dua don tro lai danh sach.
       */
      setOrders(
        current => {

          const existed =
            current.some(
              item =>
                Number(item?.order_id) ===
                Number(orderId)
            );

          if (existed) {
            return current;
          }

          return [
            order,
            ...current
          ].sort(
            (a, b) =>
              Number(
                b?.order_id || 0
              ) -
              Number(
                a?.order_id || 0
              )
          );
        }
      );


      message.error(
        `Đơn #${orderId} cập nhật thất bại, đã đưa lại vào danh sách.`
      );
    }
  };



  return (

    <div
      className="
        min-h-screen
        bg-[#f5f7fa]

        p-3
        md:p-5
        lg:p-6
      "
    >

      {/* HEADER */}

      <div
        className="
          bg-white

          rounded-2xl

          border
          border-gray-100

          shadow-sm

          p-4
          md:p-5

          mb-3
        "
      >

        <div
          className="
            flex
            items-center
            justify-between

            gap-3
          "
        >

          <div
            className="
              flex
              items-center

              gap-3

              min-w-0
            "
          >

            <div
              className="
                w-11
                h-11

                rounded-xl

                bg-orange-50
                text-orange-600

                flex
                items-center
                justify-center

                text-lg

                flex-shrink-0
              "
            >
              <ShoppingCartOutlined />
            </div>


            <div className="min-w-0">

              <h1
                className="
                  m-0

                  text-[18px]
                  md:text-2xl

                  font-bold

                  text-gray-900
                "
              >
                Đơn chưa xác nhận
              </h1>

              <div
                className="
                  text-xs
                  text-gray-500

                  mt-1
                "
              >
                Còn{" "}
                <b className="text-orange-600">
                  {orders.length}
                </b>
                {" "}đơn cần xử lý
              </div>

            </div>

          </div>


          <Button
            icon={
              <ReloadOutlined />
            }

            loading={loading}

            onClick={
              fetchOrders
            }

            className="
              !w-10
              !h-10

              !p-0

              !rounded-xl

              flex-shrink-0
            "
          />

        </div>

      </div>


      {/* HUONG DAN */}

      {orders.length > 0 && (

        <div
          className="
            mb-3

            px-3
            py-2.5

            rounded-xl

            bg-blue-50

            text-blue-700

            text-[12px]

            leading-5
          "
        >
          Xử lý từ trên xuống. Khi chuyển sang
          <b> Đang gửi hàng</b>, đơn sẽ tự biến mất khỏi danh sách.
        </div>

      )}


      <Spin spinning={loading}>

        {orders.length > 0 ? (

          <div
            className="
              flex
              flex-col

              gap-3

              max-w-[760px]
              mx-auto
            "
          >

            {orders.map(
              (order, index) => (

                <div
                  key={
                    order?.order_id
                  }

                  className="
                    bg-white

                    rounded-2xl

                    border
                    border-gray-100

                    shadow-sm

                    overflow-hidden
                  "
                >

                  {/* THONG TIN */}

                  <div className="p-4">

                    <div
                      className="
                        flex
                        items-start
                        justify-between

                        gap-3
                      "
                    >

                      <div
                        className="
                          flex
                          gap-3

                          min-w-0
                        "
                      >

                        <div
                          className="
                            w-10
                            h-10

                            rounded-full

                            bg-blue-50
                            text-blue-600

                            flex
                            items-center
                            justify-center

                            flex-shrink-0
                          "
                        >
                          <UserOutlined />
                        </div>


                        <div className="min-w-0">

                          <div
                            className="
                              text-[16px]

                              font-bold

                              text-gray-900

                              break-words
                            "
                          >
                            {
                              order?.fullname ||
                              "Chưa có tên"
                            }
                          </div>


                          <div
                            className="
                              mt-1

                              text-[12px]
                              text-gray-400
                            "
                          >
                            Mã đơn{" "}
                            <b
                              className="
                                text-gray-700
                              "
                            >
                              #{order?.order_id}
                            </b>
                          </div>

                        </div>

                      </div>


                      <div
                        className="
                          px-2.5
                          py-1

                          rounded-full

                          bg-orange-50

                          text-orange-600

                          font-semibold

                          text-[11px]

                          whitespace-nowrap
                        "
                      >
                        #{index + 1}
                      </div>

                    </div>


                    {/* TONG TIEN */}

                    <div
                      className="
                        mt-4

                        bg-gray-50

                        rounded-xl

                        px-3
                        py-3

                        flex
                        items-center
                        justify-between
                      "
                    >

                      <span
                        className="
                          text-xs
                          text-gray-500
                        "
                      >
                        Tổng thanh toán
                      </span>


                      <span
                        className="
                          text-[18px]

                          font-bold

                          text-red-500
                        "
                      >
                        {
                          FormatVND(
                            order?.total_price ||
                            0
                          )
                        }
                      </span>

                    </div>


                    {/* COPY PHONE */}

                    <button
                      type="button"

                      onClick={() =>
                        copyPhone(order)
                      }

                      className="
                        mt-3

                        w-full
                        min-h-[48px]

                        px-4

                        rounded-xl

                        border
                        border-blue-200

                        bg-blue-50

                        text-blue-700

                        flex
                        items-center
                        justify-between

                        gap-3

                        active:bg-blue-100
                      "
                    >

                      <div
                        className="
                          flex
                          items-center

                          gap-3

                          min-w-0
                        "
                      >

                        <PhoneOutlined
                          className="
                            text-lg
                          "
                        />

                        <span
                          className="
                            text-[15px]
                            font-semibold
                          "
                        >
                          {
                            order?.phone ||
                            "Không có SĐT"
                          }
                        </span>

                      </div>


                      <div
                        className="
                          flex
                          items-center

                          gap-1

                          text-xs
                          font-bold

                          flex-shrink-0
                        "
                      >
                        <CopyOutlined />
                        Copy
                      </div>

                    </button>


                    {/* COPY MESSAGE */}

                    <button
                      type="button"

                      onClick={() =>
                        copyTransferMessage(
                          order
                        )
                      }

                      className="
                        mt-2

                        w-full

                        rounded-xl

                        border
                        border-gray-200

                        bg-white

                        p-3

                        text-left

                        active:bg-gray-50
                      "
                    >

                      <div
                        className="
                          flex
                          items-center
                          justify-between

                          gap-3

                          mb-2
                        "
                      >

                        <span
                          className="
                            text-xs
                            font-bold
                            text-gray-700
                          "
                        >
                          Nội dung gửi khách
                        </span>


                        <span
                          className="
                            text-xs
                            font-bold
                            text-blue-600

                            flex
                            items-center
                            gap-1
                          "
                        >
                          <CopyOutlined />
                          Copy
                        </span>

                      </div>


                      <div
                        className="
                          text-[13px]

                          leading-5

                          text-gray-600
                        "
                      >
                        {
                          getTransferMessage(
                            order
                          )
                        }
                      </div>

                    </button>

                  </div>


                  {/* ACTION */}

                  <div
                    className="
                      border-t
                      border-gray-100

                      p-3

                      bg-gray-50
                    "
                  >

                    <Button
                      type="primary"

                      block

                      size="large"

                      icon={
                        <SendOutlined />
                      }

                      loading={false}

                      onClick={() =>
                        moveToShipping(
                          order
                        )
                      }

                      className="
                        !h-12

                        !rounded-xl

                        !font-bold
                      "
                    >
                      Chuyển sang đang gửi hàng
                    </Button>

                  </div>

                </div>

              )
            )}

          </div>

        ) : (

          !loading && (

            <div
              className="
                max-w-[600px]

                mx-auto

                bg-white

                rounded-2xl

                border
                border-gray-100

                py-16
                px-4

                text-center
              "
            >

              <div
                className="
                  w-14
                  h-14

                  mx-auto
                  mb-3

                  rounded-full

                  bg-green-50

                  text-green-600

                  flex
                  items-center
                  justify-center

                  text-xl
                "
              >
                <CheckOutlined />
              </div>


              <Empty
                image={
                  Empty.PRESENTED_IMAGE_SIMPLE
                }

                description={
                  <div>
                    <div
                      className="
                        font-bold
                        text-gray-800
                      "
                    >
                      Đã xử lý hết đơn
                    </div>

                    <div
                      className="
                        mt-1

                        text-xs
                        text-gray-400
                      "
                    >
                      Hiện không còn đơn hàng chưa xác nhận.
                    </div>
                  </div>
                }
              />

            </div>

          )

        )}

      </Spin>

    </div>
  );
}
